/**
 * Convierte una fecha a un string ISO 8601 usando la hora local del navegador,
 * evitando el desfase de zona horaria que produce Date.toISOString() (UTC).
 */
export function toLocalISOString(date: Date): string {
  const offsetMs = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offsetMs).toISOString();
}

/**
 * Devuelve una fecha con formato YYYY-MM-DD usando componentes locales.
 */
export function toLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Convierte un instante parseado desde la API (ISO con Z u offset) al mismo criterio
 * de calendario local que usa el datepicker al cargar fechas de asignación.
 */
export function utcToLocalDate(dateStr: string): Date {
  const date = new Date(dateStr);
  const offsetInMinutes = date.getTimezoneOffset();
  return new Date(date.getTime() + offsetInMinutes * 60000);
}

/**
 * `YYYY-MM-DD` civil local a partir de un valor devuelto por la API (ISO o solo fecha).
 * Alinea dashboard declarante, conteos de días y formulario de asignación.
 */
export function toLocalCalendarDayFromApiDateString(
  dateStr: string,
): string | null {
  const s = dateStr?.trim() ?? '';
  if (!s) return null;
  const parsed = new Date(s);
  if (Number.isNaN(parsed.getTime())) {
    const m = /^\d{4}-\d{2}-\d{2}/.exec(s);
    return m ? m[0] : null;
  }
  return toLocalDateString(utcToLocalDate(s));
}
